import { ApiApplicationStatus } from 'api/types/ApiApplicationStatus';
import { colors } from 'theme/theme';

export const APPLICATION_STATUSES_ALL: Record<ApiApplicationStatus, string> = {
  APPLIED:
    /* Status */
    getText('Applied'),
  UNDER_CONSIDERATION:
    /* Status */
    getText('Under Consideration'),
  INTERVIEWING:
    /* Status */
    getText('Interviewing'),
  MADE_OFFER:
    /* Status */
    getText('Made Offer'),
  HIRED:
    /* Status */
    getText('Hired'),
  DISQUALIFIED:
    /* Status */
    getText('Disqualified'),
};

export type PagesToShowByApplicationStatus = Record<
  ApiApplicationStatus,
  number
>;

export const APPLICATION_STATUSES_ALL_KEYS = Object.keys(
  APPLICATION_STATUSES_ALL,
) as ApiApplicationStatus[];

export const ATS_LINK_WARNINGS = {
  EMAIL: getText(
    `Did you mean to include an email address? Idealist won’t be able to track applicants who email you directly.`,
  ),
  URL: getText(
    `Did you mean to include a URL? Idealist won’t be able to track applicants who apply off-site.`,
  ),
  BOTH: getText(
    `Did you mean to include an email address or URL? Idealist won’t be able to track applicants who email you directly or apply off-site.`,
  ),
};
// before that date, referrers were not tracked, so we don't want to show wrong data
export const APPLICATION_REFERRER_SUPPORT_DATE = '2021-04-07T12:00:00.000Z';

const COLOR_MAP = {
  APPLIED: {
    bg: colors.skyBlue,
    color: 'white',
  },
  UNDER_CONSIDERATION: {
    bg: colors.brandBlue,
    color: 'white',
  },
  INTERVIEWING: {
    bg: colors.brightPlum,
    color: 'white',
  },
  MADE_OFFER: {
    bg: colors.brandYellow,
    color: colors.darkContentGrey,
  },
  HIRED: {
    bg: colors.brandGreen,
    color: 'white',
  },
  DISQUALIFIED: {
    bg: colors.elementGrey,
    color: colors.darkContentGrey,
  },
};

export const getColor = (key: keyof typeof COLOR_MAP) =>
  COLOR_MAP[key] || COLOR_MAP.APPLIED;
